<template>
<div>
  <div class="curr-info ">
    <div class="info-vehicle info-template">
      <h3>车辆信息</h3>
      <div v-if="!yhcgbaztslot&&!yhctbaztslot">
        <div class="chetou-info">
          <div class="info-item">车头号：{{chetouInfo.chetouhao}}</div>
          <div class="info-item">车头行驶证有效期：{{chetouInfo.xingshizhengyxq}}</div>
        </div>
        <div class="chegua-info">
          <div class="info-item">车挂号：{{cheguaInfo.cheguahao}}</div>
          <div class="info-item">车挂行驶证有效期：{{cheguaInfo.xingshizhengyxq}}</div>
          <div class="info-item">车挂核定载质量：{{cheguaInfo.xingshizhenghdzzl?cheguaInfo.xingshizhenghdzzl:0}}吨(T)</div>
        </div>
      </div>
      <div v-else>
        <div class="show-error-message">
          请完成车辆绑定以及备案
        </div>
      </div>

    </div>

    <div class="user-jsy-info info-template">
      <h3>驾驶员信息</h3>
      <div v-if="!yhjsybaztslot">
        <div class="jsy-info">
          <div class="info-item">驾驶员：{{driverInfo.name}}</div>
          <div class="info-item">身份证：{{driverInfo.shenfenzheng}}</div>
        </div>
      </div>
      <div v-else>
        <div class="show-error-message">
          请完成驾驶员信息添加以及备案
        </div>
      </div>

    </div>
    <div class="user-escort-info info-template">
      <h3>押送员信息</h3>
      <div v-if="!yhyyybaztslot">
        <div class="escort-info">
          <div class="info-item">押送员：{{escortInfo.name}}</div>
          <div class="info-item">身份证：{{escortInfo.shenfenzheng}}</div>
        </div>
      </div>
      <div v-else>
        <div class="show-error-message">
          请完成押送员信息添加以及备案
        </div>
      </div>

    </div>
  </div>

  <div class="input-number-box">
    <van-form @submit="onSubmit">
      <van-field v-model="inputYyNumber" label-width="6.5rem" type="number" name="预约数量（吨）" required :rules="[{ validator:validatorInputYyNumber, message: '请输入预约数量' }]" placeholder="请输入预约数量">
        <template #label>
          <span class="input-left-label-hq">预约数量（吨）</span>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" color="#316892">提交</van-button>
      </div>
    </van-form>
  </div>
  <Tabbar></Tabbar>
</div>
</template>
<script>
import api from '@/fetch/api'
import Tabbar from '../Public/tabbarTpl.vue'
import {
  Toast,
  Dialog
} from 'vant'
export default {
  components: {
    Tabbar
  },
  created() {
    document.title = "预约信息确认";
    var openid = this.$store.state.wx_info.openid;
    this.openid = openid;
    //根绝时间判定maxDate
    this.getMaxDate();

    //判断绑定信息
    this.getBindVehicleState();
    //获取绑定车辆信息
    this.getVehicleInfo();
    //获取驾驶员/押送员信息
    this.getDriverByOpenid();
    this.getEscortByOpenid();
    this.getSysInfo();
  },
  data() {
    return {
      openid: "",
      inputYyNumber: 0,
      yhcgbaztslot: false,
      yhctbaztslot: false,
      yhjsybaztslot: false,
      yhyyybaztslot: false,
      chetouInfo: [],
      cheguaInfo: [],
      driverInfo: [],
      escortInfo: [],
      columns:[],
      showTimePicker: false,
      cctwly:0,//cctwly 新版本
      minDate: new Date(),
      maxDate: new Date(2099, 11, 31),
      currentDate: new Date(),
      showTimePicker2:false,
      showPicker: false,
      showField: false,
    }
  },
  methods: {
    getMaxDate()
    {
      const now = new Date();
      // 获取当前的小时数
      const currentHour = now.getHours();
      const tomorrow = new Date(now);
      // 判断当前时间是否超过晚上6点
      if (currentHour >= 18) {

        tomorrow.setDate(now.getDate() + 1);
        this.maxDate = tomorrow;
      }
      // 如果在晚上6点之前，则maxDate为今天的日期，但时间设为晚上6点之前的一毫秒
      else{
        this.maxDate = tomorrow;
      }
    },
    validatorInputYyNumber(val) {
      if (!val || parseFloat(val) > 49) {
        Toast.fail('请填写正确的预约数量');
        return false;
      }
    },
    //输入预约数量
    onSubmit() {
      if (this.yhcgbaztslot || this.yhctbaztslot) {
        Dialog({
          message: '请完成车辆绑定以及备案'
        });
        return false;
      }
      if (this.yhjsybaztslot) {
        Dialog({
          message: '请完成驾驶员信息添加以及备案'
        });
        return false;
      }
      if (this.yhyyybaztslot) {
        Dialog({
          message: '请完成押送员信息添加以及备案'
        });
        return false;
      }

      if (this.inputYyNumber <= 0) {
        Dialog({
          message: '请填写您要预约的数量'
        });
        return false;
      }

      var type = this.$route.params.type;
      if (type == "th") {
        this.$router.push({
          name: 'appointment',
          params: {
            number: this.inputYyNumber,
          }
        })
      } else if (type == "xh") {
        this.$router.push({
          name: 'appointmentxh',
          params: {
            number: this.inputYyNumber,
          }
        })
      } else {
        this.$router.push({
          name: 'index'
        })
      }
    },
    //判断绑定信息
    getBindVehicleState() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api.getBindVehicleState(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          that.$data.vehicleState = res.data.yhzt;
          var yhcgbazt = res.data.yhcgbazt;
          var yhctbazt = res.data.yhctbazt;
          var yhjsybazt = res.data.yhjsybazt;
          var yhyyybazt = res.data.yhyyybazt;
          let yhcgbaztslot = 0,
            yhctbaztslot = 0,
            yhjsybaztslot = 0,
            yhyyybaztslot = 0;
          if (yhcgbazt == "0" || yhcgbazt == "1") yhcgbaztslot++;
          if (yhctbazt == "0" || yhctbazt == "1") yhctbaztslot++;
          if (yhjsybazt == "0" || yhjsybazt == "1") yhjsybaztslot++;
          if (yhyyybazt == "0" || yhyyybazt == "1") yhyyybaztslot++;
          that.yhcgbaztslot = yhcgbaztslot ? true : false;
          that.yhctbaztslot = yhctbaztslot ? true : false;
          that.yhjsybaztslot = yhjsybaztslot ? true : false;
          that.yhyyybaztslot = yhyyybaztslot ? true : false;
          that.yhctbaztslot = false; //正式环境需要删除
        }
      }).catch(function() {
        //
      });
    },
    //获取车辆xinxi
    getVehicleInfo() {
      var that = this;
      var openid = that.openid;
      if (!that.yhctbaztslot && !that.yhcgbaztslot) {
        //车头信息
        api.getChetouBeianDetail(openid).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            var detail = res.data;
            if(detail.vehicleUsage == '2') that.chetouInfo = detail;
          }
        }).catch(function() {
          Toast.fail('连接失败，请刷新页面');
        });

        //获取车挂id
        api.getVehicleInfo(openid).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            var cheguaid = res.data.cheguaid;
            //车挂信息
            api.getCheguaBeianDetail(cheguaid).then(function(resDataNew) {
              var resNew = JSON.parse(resDataNew);
              if (res.respCode == 0) {
                 var detail = resNew.data;
                if(detail.vehicleUsage == '2') that.cheguaInfo = detail;

                //that.cheguaInfo = resNew.data;
              }
            }).catch(function() {
              Toast.fail('连接失败，请刷新页面');
            });
          }
        }).catch(function() {
          Toast.fail('连接失败，请刷新页面');
        });
      }
    },
    //获取驾驶员信息
    getDriverByOpenid() {
      var that = this;
      var openid = that.openid;
      api.getDriverByOpenid(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var detail = resData.data;
          that.driverInfo = detail[0];
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
    //获取押送员信息
    getEscortByOpenid() {
      var that = this;
      var openid = that.openid;
      api.getEscortByOpenid(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var detail = resData.data;
          that.escortInfo = detail[0];
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');

      });
    },
    //获取系统信息
    getSysInfo()
    {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      //获取系统信息
      api.getSysInfo(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var cctwly = res.data.cctwly;
          that.cctwly = cctwly;
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.info-template {
    background: #fff;
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    line-height: 1.5;
    color: #455a64;
    font-size: 0.875rem;
    h3 {
        font-weight: 600;
        color: #455a64;
        font-size: 1.125rem;
    }
}

.chegua-info {
    margin-top: 0.5rem;
}

.input-number-box {
    margin-top: 1rem;
}

.show-error-message {
    color: #ee0a24;
}
</style>
